module.exports = __webpack_public_path__ + "img/treefriendsthumb.fc6405aa.jpg";